<template>
  <div class="col-sm-12">
    <div class="card border-0 shadow">
      <h3 class="card-header border-0 bg-secondary">
        Asociacion de
        <strong>Productos</strong>
        <br />
        <small class="text-muted text-xs">Productos asociados</small>
      </h3>

      <!-- <div class="card-header border-0 bg-secondary">Productos asociados al plan seleccionado</div> -->
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="bg-secondary text-dark font-weight-bold">
              <tr>
                <td>Nombre</td>
                <td>Asociado el</td>
                <td>Última actualización</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr v-if="products.length == 0">
                <td colspan="5" class="text-muted">No hay Productos asociados</td>
              </tr>
              <template v-for="(p, pIndex) in products">
                <tr :key="'pKey_'+pIndex">
                  <td>
                    {{p.name}}
                    <br />
                    <span class="text-muted text-xs">{{p.description}}</span>
                  </td>
                  <td>
                    <template v-if="p.id > 0">
                      <span class="text-capitalize">{{p.create_date | formatDate}}</span>
                      <br />
                      <span class="text-muted text-xs">Por: {{ p.user }}</span>
                    </template>
                    <template v-else>
                      <span class="text-muted text-xs font-italic">Nunca asociado</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="p.update_user">
                      <span class="text-capitalize">{{p.update_date | formatDate}}</span>
                      <br />
                      <span class="text-muted text-xs">Por: {{ p.update_user }}</span>
                    </template>
                    <template v-else>
                      <span class="text-muted text-xs">--</span>
                    </template>
                  </td>
                  <td style="width:100px;">
                    <button
                      :disabled="!actions.put"
                      @click="toggleItem(p)"
                      v-b-tooltip.hover
                      title="Click para cambiar"
                      class="btn btn-sm btn-block btn-secondary pl-2 pr-2"
                      v-text="p.active ? 'Asociado':'No asociado'"
                      :class="p.active ? 'text-success':'text-danger'"
                    ></button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer text-right" v-if="actions.put">
        <div class="alert text-dark p-3 mb-2 fadeIn">
          <i class="fa fa-info-circle text-info"></i> Haz click en
          <strong>Actualizar</strong> para guardar los cambios.
        </div>
        <button
          v-if="products.length > 0"
          class="btn btn-info"
          @click="handleSubmit"
          type="button"
        >Actualizar</button>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/helpers/utils";
import Auth from "@/helpers/middleware";
export default {
  name: "PlanAsosiaciones",
  props: ["products", "actions"],
  data() {
    return {
      user: Auth.getUser()
    };
  },
  filters: {
    formatDate(val) {
      return utils.formatDateTime(val);
    }
  },
  methods: {
    toggleItem(item) {
      this.products.map(i =>
        i.user == 0 ? (i.user = this.user.email) : false
      );
      item.active = !item.active;
    },
    handleSubmit() {
      this.$parent.handleSetPlan();
    }
  }
};
</script>